var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-container",
      class: { "has-gray-background": _vm.hasGrayBackground },
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.login($event)
        },
        input: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.doNothing($event)
        },
        change: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.doNothing($event)
        },
        keyup: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.doNothing($event)
        }
      }
    },
    [
      _vm.hasGrayBackground
        ? _c("h2", [_vm._v("LOGIN TO "), _vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("error", { staticClass: "login-error" }, [
            _vm._v(
              "\n        Error: Your login information is incorrect. Please check your details and try again or "
            ),
            _c(
              "a",
              { attrs: { href: "#0" }, on: { click: _vm.resetPasswordSlider } },
              [_vm._v("reset your password")]
            ),
            _vm._v(" now.\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("error-list", {
            staticClass: "login-error",
            attrs: { messages: _vm.errors.items }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "f9field",
        [
          _c(
            "span",
            {
              staticClass: "slider-label",
              attrs: { slot: "label" },
              slot: "label"
            },
            [
              _vm._v("Email Address or "),
              _c("i", [_vm._v("FRONTIER Miles")]),
              _c("small", [_vm._v("sm")]),
              _vm._v(" #")
            ]
          ),
          _vm._v(" "),
          _c("f9input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              saved: !_vm.changed,
              type: "text",
              autocomplete: "off",
              name: "email",
              "data-vv-scope": _vm.validationScope
            },
            on: {
              change: function($event) {
                _vm.changed = true
              }
            },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "f9field",
        [
          _c(
            "span",
            {
              staticClass: "slider-label",
              attrs: { slot: "label" },
              slot: "label"
            },
            [_vm._v("Password")]
          ),
          _vm._v(" "),
          _c("f9input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              saved: !_vm.changed,
              type: "password",
              autocomplete: "off",
              name: "password",
              "data-vv-scope": _vm.validationScope
            },
            on: { change: _vm.onChange },
            model: {
              value: _vm.password,
              callback: function($$v) {
                _vm.password = $$v
              },
              expression: "password"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "f9button",
        {
          ref: "submitButton",
          attrs: {
            disabled: !_vm.changed,
            name: "submit",
            loading: _vm.submitting
          },
          on: { click: _vm.login }
        },
        [_vm._v("LOG IN")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "l" }, [
        _c(
          "a",
          {
            staticClass: "login-forgot link",
            attrs: { role: "button", tabindex: "0" },
            on: { click: _vm.resetPasswordSlider }
          },
          [_vm._v("Forgot Password?")]
        )
      ]),
      _vm._v(" "),
      _vm.hasGrayBackground ? _c("div", { staticClass: "hr" }) : _vm._e(),
      _vm._v(" "),
      _vm.showSignup
        ? _c("div", { staticClass: "login-footer" }, [
            _c(
              "div",
              { staticClass: "login-footer-bold" },
              [
                _vm._v("\n            NOT A MEMBER?\n            "),
                _c(
                  "f9button",
                  {
                    staticClass: "link join-now",
                    attrs: { nostyle: "" },
                    on: {
                      click: function($event) {
                        _vm.signUpSlider(0)
                      }
                    }
                  },
                  [_vm._v("SIGN UP")]
                ),
                _vm._v("\n            TODAY!\n        ")
              ],
              1
            ),
            _vm._v(" "),
            !_vm.hasGrayBackground
              ? _c("div", { staticClass: "login-footer-small" }, [
                  _vm._v(
                    "\n            Earn miles towards your next trip by joining our Frequent Flyer Program today!\n        "
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hidePasswordReset
        ? _c(
            "slider",
            {
              ref: "forgotSlider",
              attrs: {
                title: "PASSWORD RESET",
                "modal-opacity": _vm.forgotModalOpacity
              },
              model: {
                value: _vm.forgotSliderOpen,
                callback: function($$v) {
                  _vm.forgotSliderOpen = $$v
                },
                expression: "forgotSliderOpen"
              }
            },
            [
              _c("forgot-password", {
                attrs: {
                  email: _vm.email,
                  "slider-open": _vm.forgotSliderOpen
                },
                on: { reset: _vm.passwordIsReset }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSignup
        ? _c(
            "slider",
            {
              ref: "signupSlider",
              attrs: {
                title: "SIGN UP",
                "modal-opacity": _vm.signUpSliderOpacity
              }
            },
            [
              _c("signup", {
                attrs: {
                  "show-success": _vm.showSignupSuccess,
                  "reload-on-login": _vm.reloadOnLogin
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [_vm._v("FRONTIER MILES"), _c("small", [_vm._v("sm")])])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-493f842a", { render: render, staticRenderFns: staticRenderFns })
  }
}